import Swiper, {Navigation, Pagination, Autoplay} from 'swiper'
Swiper.use([Navigation, Pagination, Autoplay]);

export default function sliders() {
    (function($) {
        $(window).on('load', function () {
           // get all sliders, we need to loop them due to different settings + nav
           var swipers = document.querySelectorAll('.reviews-swiper');
           swipers.forEach(function(el,index){
            var closestSection = el.closest('section');
            var controls = closestSection.querySelector('.control');

                // slider settings
                var options = {
                    speed: 600,
                    loop: true,
                    //autoplay: {
                        //delay: 5000,
                        //disableOnInteraction: true,
                    //},
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    freeMode: true,
                    centeredSlides: true,
                    slidesPerView: 1,
                    spaceBetween: 30,
                    on: {
                        slideChange: (swiper) => {
                            let image =
                            swiper.slides[
                            swiper.activeIndex
                            ].querySelector('img[data-src]')
                            if (image) {
                                loadSlideImage(image);
                            }
                        },
                    },

                    breakpoints: {
                      640: {
                        spaceBetween: 30,
                        slidesPerView: 1,
                    },
                    992: {
                        spaceBetween: 30,
                    },
                    1172: {
                        spaceBetween: 34,
                        slidesPerView: 1,
                    },
                },
            };

                // init slider
                new Swiper(el, options);
            });
       })

    })( jQuery );

    (function($) {
        $(window).on('load', function () {
           // get all sliders, we need to loop them due to different settings + nav
           var swipers = document.querySelectorAll('.alt-reviews-gallery');
           swipers.forEach(function(el,index){
            var closestSection = el.closest('section');
            var controls = closestSection.querySelector('.control');

                 // slider settings
                var options = {
                    speed: 600,
                    loop: false,
                    autoHeight: true,
                    //autoplay: {
                        //delay: 5000,
                        //disableOnInteraction: true,
                    //},
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    freeMode: true,
                    centeredSlides: true,
                    slidesPerView: 1,
                    spaceBetween: 20,
                    autoHeight: true,
                    on: {
                        slideChange: (swiper) => {
                            let image =
                            swiper.slides[
                            swiper.activeIndex
                            ].querySelector('img[data-src]')
                            if (image) {
                                loadSlideImage(image);
                            }
                        },
                    },

                    breakpoints: {
                      640: {
                        spaceBetween: 10,
                        slidesPerView: 1,
                    },
                    992: {
                        spaceBetween: 10,
                    },
                    1172: {
                        spaceBetween: 15,
                        slidesPerView: 1,
                    },
                },
            };

                // init slider
                new Swiper(el, options);
            });
       })

    })( jQuery );
}


function loadSlideImage(image) {
    let src = image.getAttribute('[data-src]')
    let sourceSet = image.parentNode.querySelectorAll('[data-srcset]')
    if (sourceSet.length > 0) {
        for (let i = 0; i < sourceSet.length; i++) {
            sourceSet[i].srcset = sourceSet[i].getAttribute('data-srcset')
        }
    }
    if ('img' === image.tagName.toLowerCase()) {
        if (src) {
            image.src = src
        }
    } else {
        image.style.backgroundImage = "url('" + src + "')"
    }
}